










import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { IStore } from '@/system/store'
import moment from 'moment'

@Component
export default class JobDetailsBottomBar extends Vue {
  private translations = jobDetailsLocalisationKeys

  @State(({ job }: IStore) => moment(job.selectedJob.createdAt).format('YYYY-MM-DD HH:mm')) createdAt!: moment.Moment

  @Emit('downloadFile')
  emitDownloadFile (): void {}

  @Emit('removeJob')
  showRemoveDialog (): void {}
}
